import React from 'react'
import { Column, Table } from '@tencent/spaui-table'
// import AlertTips from 'pureComponents/AlertTips'
// import DialogInputLabel from 'pureComponents/DialogInputLabel'
// import { getWarningMsg } from '../UploadChannelPkg/utils'
import useUploadResults from './hooks/useUploadResults'

const UploadResults = props => {
    const { successRecords, failedRecords } = useUploadResults(props)
    let index = 1
    failedRecords.forEach(item => {
        item.index = index++
        item.retStatus = `失败(${item.ret})`
        item.className = 'status-row-fail'
    })
    successRecords.forEach(item => {
        item.index = index++
        item.retStatus = '成功'
        item.className = 'status-row-success'
    })
    const rows = failedRecords.concat(successRecords)
    return (
        <Table data={rows} setTrClassName={(type, data) => (data && data.className) || ''} fixedHeight={350}>
            <Column name="index" maxWidth="60">
                行号
            </Column>
            <Column name="channelName" minWidth="150">
                渠道包名称
            </Column>
            <Column name="channelKey" minWidth="150">
                key值
            </Column>
            <Column name="retStatus" minWidth="150">
                状态
            </Column>
            <Column name="msg" minWidth="150">
                消息
            </Column>
        </Table>
    )
}

export default UploadResults
